import React from 'react';
import { Button } from '@milanote/roma';

import { useTranslator } from '../../../../../../components/i18n/useTranslator';

type Props = {
    onDelete: () => void;
    onCancel?: () => void;
};

const LabelDeleteConfirmationContent = ({ onDelete, onCancel }: Props) => {
    const translate = useTranslator('popup', 'labels.edit');

    return (
        <div className="flex flex-col gap-xl">
            <p className="text-center text-md text-secondary">{translate('deleteDescription')}</p>

            <div className="flex gap-3">
                <Button color="secondary" size="md" className="flex-1" onClick={onCancel}>
                    {translate('deleteCancel')}
                </Button>
                <Button color="primary-destructive" size="md" className="flex-1" onClick={onDelete}>
                    {translate('deleteConfirm')}
                </Button>
            </div>
        </div>
    );
};

export default LabelDeleteConfirmationContent;
